/* eslint-disable @nx/enforce-module-boundaries */
import { CheckMark1, ChevronDown, NewGlobe } from '@mybridge/icons';
import { HStack } from '@mybridge/ui/layout';
import {
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
} from '@mybridge/ui/menu';

import { Text } from '@mybridge/ui/text';
import { useContext, useState, useRef } from 'react';
import { PostVisibilityOptions } from '../../../snippets/dashboard/constants';
import { PostFormContext } from '../context';
import { Portal } from '@mybridge/ui';

import { useEffect } from 'react';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const CommentControlMenu = () => {
  const {
    replyControl = PostVisibilityOptions?.[0]?.value,
    setReplyControl,
    isControlMenuOpen,
    visibility,
    setVisibility,
    setIsControlMenuOpen,
    setIsReactionMenuOpen,
  } = useContext(PostFormContext);
  const { t } = useTranslator();

  // Filter visibility options based on the passed visibility prop
  const filteredVisibilityOptions = PostVisibilityOptions.filter((option) => {
    if (visibility === 0 || visibility === undefined) return true; // Everyone can see all options
    if (visibility === 2) return option.value !== 0; // myCircle & followers can see myCircle & followers and myCircle
    if (visibility === 1) return option.value === 1; // myCircle can only see myCircle
  });

  // State management
  const [menuOpen, setMenuOpen] = useState(false);
  const prevVisibilityRef = useRef(visibility);

  const replyControl_ = filteredVisibilityOptions?.find?.(
    (rc) => rc?.value === replyControl
  );

  const displayLabel = replyControl_
    ? t(replyControl_.translationKey) || replyControl_.title
    : t('createPost.whoCanReply') || 'Who can reply?';

  useEffect(() => {
    if (prevVisibilityRef.current !== visibility) {
      setReplyControl(visibility);
      prevVisibilityRef.current = visibility;
    }
  }, [visibility, setReplyControl]);

  // useEffect(() => {
  //   // Set the default reply control and selected option when the component mounts
  //   // if (visibility === 2) {
  //   //   // Automatically set the reply control to 2 if visibility is myCircle & followers
  //   //   setReplyControl(2);
  //   // }
  //   // else if (filteredVisibilityOptions.length > 0) {
  //   //   setReplyControl(filteredVisibilityOptions[0]?.value);
  //   // }
  //   if (replyControl === undefined) {
  //     if (visibility === 2) {
  //       setReplyControl(2);
  //     } else if (filteredVisibilityOptions.length > 0) {
  //       setReplyControl(filteredVisibilityOptions[0]?.value);
  //     }
  //   }
  // }, [visibility, filteredVisibilityOptions, setReplyControl, replyControl]);

  useEffect(() => {
    if (filteredVisibilityOptions.length > 0) {
      // If current replyControl is not valid anymore, reset it
      const stillValid = filteredVisibilityOptions.some(
        (opt) => opt.value === replyControl
      );

      if (!stillValid) {
        setReplyControl(filteredVisibilityOptions[0].value);
      }
    }
  }, [visibility, filteredVisibilityOptions, replyControl, setReplyControl]);

  // const replyControl_ = filteredVisibilityOptions?.find?.(
  //   (rc) => rc?.value === replyControl
  // );

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  return (
    <>
      {isControlMenuOpen ? (
        <HStack>
          {replyControl_?.icon}
          <Text
            onClick={() => {
              setMenuOpen(true);
              setIsControlMenuOpen(!isControlMenuOpen);
              setIsReactionMenuOpen(isControlMenuOpen);
            }}
          >
            {displayLabel}
          </Text>
        </HStack>
      ) : (
        <Menu zIndex="1" onClose={handleMenuClose} isOpen={menuOpen}>
          <MenuButton
            variant="transparent"
            color="#5B5B5B"
            fontSize="sm"
            width="202px"
            css={{
              '@media (min-width: 768px) and (max-width: 1280px)': {
                width: '50%',
              },
            }}
            height="40px"
            padding="10px 14px"
            borderRadius="20px"
            boxShadow="0px 2px 6px 0px #00000033"
            onClick={() => {
              setMenuOpen(!menuOpen);
              setIsControlMenuOpen(isControlMenuOpen);
              setIsReactionMenuOpen(!isControlMenuOpen);
            }}
          >
            <HStack>
              {replyControl_?.icon}
              <Text color="gray.700">
                <Text color="gray.600">
                  {t(replyControl_?.translationKey) || replyControl_?.title}
                </Text>
              </Text>
            </HStack>
          </MenuButton>

          <Portal>
            <MenuList
              zIndex={10000}
              shadow="base"
              // position="absolute"
              // top="-50px"
              minWidth="auto"
              width="202px"
              // borderRadius="20px 20px 10px 10px"
              borderRadius="20px 20px 10px 10px"
            >
              <MenuGroup>
                {/* <HStack
                  padding="6px 12px"
                  borderBottom="1px solid #E4E6EB"
                  onClick={() => {
                    setSelectedOption(t('createPost.whoCanReply') || "Who can reply?");
                    handleMenuClose();
                  }}
                >
                  {replyControl_?.icon}
                  <Text color="gray.700">{t('createPost.whoCanReply') || "Who can reply?"}</Text>
                </HStack> */}
                <HStack
                  padding="6px 12px"
                  borderBottom="1px solid #E4E6EB"
                >
                  {replyControl_?.icon}
                  <Text color="gray.600">{t('createPost.whoCanReply') || "Who can reply?"}</Text>
                </HStack>
                {filteredVisibilityOptions.map((vo, voind) => (
                  <MenuItem
                    key={voind}
                    /* onClick={() => {
                      setReplyControl(vo?.value);
                      // setSelectedOption(t(vo.translationKey) || vo?.title);
                    }} */
                    onClick={() => {
                      setReplyControl(vo?.value);
                      setVisibility(vo?.value);
                      // setSelectedOption(t(vo.translationKey) || vo?.title);
                    }}
                    icon={vo.icon}
                  >
                    <HStack>
                      <Text flex={1}>{t(vo.translationKey) || vo.title}</Text>
                      {vo?.value === replyControl ? <CheckMark1 /> : ''}
                    </HStack>
                  </MenuItem>
                ))}
              </MenuGroup>
            </MenuList>
          </Portal>
        </Menu>
      )}
    </>
  );
};
